import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function Popup({
    open,
    handleClose,
    title,
    children,
    handleSubmit,
    save = true,
    isSave = true,
    maxWidth = "md",
    saveText = "Save"
}) {

    return (
        <>
            <Dialog
                sx={{ 
                    ".MuiDialog-paper": { 
                        borderRadius: 3,
                        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                    } 
                }}
                open={open}
                maxWidth={maxWidth}
                fullWidth={true}
                onClose={handleClose}
                TransitionProps={{
                    timeout: 300,
                }}
                id={title}
            >
                <DialogTitle 
                    sx={{ 
                        paddingBottom: "12px", 
                        paddingTop: "16px", 
                        px: 2,
                        display: "flex", 
                        justifyContent: "space-between",
                        alignItems: "center",
                        background: 'linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%)',
                        borderBottom: '1px solid rgba(0, 0, 0, 0.08)',
                    }}
                >
                    <Typography id="keep-mounted-modal-title" variant="h6" sx={{ fontWeight: 600, fontSize: '1.1rem' }}>
                        {title}
                    </Typography>
                    <IconButton 
                        onClick={handleClose}
                        sx={{
                            color: 'grey.700',
                            transition: 'transform 0.2s ease',
                            '&:hover': {
                                transform: 'rotate(90deg)',
                                backgroundColor: 'rgba(0, 0, 0, 0.06)',
                                color: 'grey.900',
                            }
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ pt: 2, px: 2 }}>
                    {children}
                    <Box sx={{ textAlign: "right", mt: 2, pt: 1.5, borderTop: '1px solid rgba(0, 0, 0, 0.08)' }}>
                        <Button 
                            onClick={handleClose} 
                            color="primary"
                            variant='outlined'
                            size="small"
                            sx={{
                                borderRadius: 1.5,
                                px: 2,
                                py: 0.5,
                                textTransform: 'none',
                                fontWeight: 600,
                                borderColor: 'primary.main',
                                color: 'primary.main',
                                '&:hover': {
                                    borderColor: 'primary.dark',
                                    backgroundColor: 'action.hover',
                                },
                            }}
                        >
                            Close
                        </Button>
                        {isSave && (
                            <Button 
                                sx={{ ml: 1.5 }} 
                                onClick={() => handleSubmit()} 
                                disabled={!save} 
                                color='primary' 
                                variant='contained'
                                size="small"
                                sx={{
                                    borderRadius: 1.5,
                                    px: 2,
                                    py: 0.5,
                                    textTransform: 'none',
                                    fontWeight: 600,
                                    boxShadow: '0 2px 8px rgba(139, 68, 255, 0.3)',
                                    '&:hover': {
                                        boxShadow: '0 4px 12px rgba(139, 68, 255, 0.4)',
                                    },
                                    '&:disabled': {
                                        opacity: 0.5,
                                    }
                                }}
                            >
                                {saveText}
                            </Button>
                        )}
                    </Box>
                </DialogContent>

            </Dialog>
        </>
    );
}
